import { render, staticRenderFns } from "./DistributePageMessageTrigger.vue?vue&type=template&id=877b11b6"
import script from "./DistributePageMessageTrigger.vue?vue&type=script&lang=js"
export * from "./DistributePageMessageTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports